import { Application, LanguageManager, Managers } from "@levelapp/softfabric";
import Translation from "../DTO/Translation";

class Helpers {

    static formatAmount(amount: number | string) {
        const value = Number(amount) || 0;
        return value.toLocaleString('de-DE', { maximumFractionDigits: 0 }) + ' €';
    }

    static getCurrentLanguage() {
        let language = Application.current.resolve<LanguageManager>(Managers.LANGUAGE_MANAGER).language;
        switch (language) {
            case "fr-BE":
                return "FR";
            case "nl-BE":
                return "NL";
            case "en-GB":
                return "EN";
            default:
                return "FR";
        }
    }

    static getCorrectTranslation(text: Translation) {
        if (!text)
            return '';
        let language = Application.current.resolve<LanguageManager>(Managers.LANGUAGE_MANAGER).language;
        switch (language) {
            case "fr-BE":
                return text.fr;
            case "nl-BE":
                return text.nl;
            case "en-GB":
                return text.en;
            default:
                return text.fr;
        }
    }

    static getPropertyValue(key: string, properties: any) {
        let value = properties.filter((x: any) => x.projectPropertyKey.key === key)[0];
        if (!value)
            return "";
        if (value.valueTranslated) {
            return this.getCorrectTranslation(value.valueTranslated);
        }
        return value.value;
    }
}

export default Helpers